import * as Yup from 'yup'
import {TabOption} from '../../../../shared/components/FormTabHeader'
import { AsyncCustomerModel } from '../../../../shared/models/ApiModels'

export interface IReservationSource {
  id?: string
  reservationSourceName: string
  company?: AsyncCustomerModel | null 
  companyId: string
  serviceCurrency?: string
  workingOffice?: string
  type?: string

  maxDays?: number
  babyseat?: number
  navigation?: number

  balancingType?: string
  balancingTransaction?: string
  balancePercentage?: number
  balanceAmount?: number
  tariffType?: string

  status?: string
  fullCreditLocation?: string

  additionalDriver?: number
  wifi?: number
  mandatoryServiceFee?: number

  kdvExemptionAvailable?: boolean
  xmlServiceSpecial?: boolean
  xmlCompanyMailNotification?: boolean
  scdwIncluded?: boolean
  cdwIncluded?: boolean
  lcfIncluded?: boolean
  paiIncluded?: boolean

  faz1Timeout?: number
  faz2Timeout?: number
  automaticMailSms?: string
  xmlPaymentType?: string
  secretOption?: string
  riskAnalysis?: string
  nameDisplay?: string
  balanceNonRentConversion?: string

  automaticNoShowDuration?: number
  futureInvoiceRate?: number
  xmlPriceMultiplier?: number
  xmlServiceMultiplier?: number
  xmlAdvancePaymentRate?: number
  frameCode?: string

  agencyPriceChange?: string
  extensionProcess?: string
  provisionType?: string
  unlimitedKm?: string
  coefficientCostRelationship?: string
}

export type Option = {label: string; value: string}

export const RESERVATION_TABS: TabOption<string>[] = [
  {key: 'form', title: 'Rezervasyon Kaynağı'},
  {key: 'details', title: 'Ayrıntılar'},
  {key: 'media', title: 'Makale / Resim'},
  {key: 'prices', title: 'Fiyatlar'},
  {key: 'list', title: 'Rez. Kaynağı Listesi'},
]
 
export const BALANCING_TYPE: Option[] = [
  {label: 'Serbest', value: '0'},
  {label: 'Ekstralar Müşteriye Ait', value: '1'},
  {label: 'Full Credit', value: '2'},
  {label: 'Diğer', value: '3'},
]
export const BALANCING_TX: Option[] = [
  {label: 'Değiştirme', value: '0'},
  {label: 'Rez. Kaynağı Borçlu', value: '1'},
  {label: 'Rez. Kaynağı Komisyonlu', value: '2'},
]
export const TARIFFS: Option[] = [
  {label: 'Temel(Yok)', value: '0'},
  {label: 'Özel XML Tarife', value: '1'}, 
]
export const GO_GO_NOT: Option[] = [
  {label: 'Gitsin', value: 'Gitsin'},
  {label: 'Gitmesin', value: 'Gitmesin'},
]
export const SHOW_HIDE: Option[] = [
  {label: 'Göster', value: 'Göster'},
  {label: 'Gizle', value: 'Gizle'},
]
export const RISK: Option[] = [
  {label: 'Yapsın', value: 'Yapsın'},
  {label: 'Yapmasın', value: 'Yapmasın'},
]
export const NAME_DISPLAY: Option[] = [
  {label: 'Göster', value: 'Göster'},
  {label: 'Gösterme', value: 'Gösterme'},
]
export const IMPORTANCE: Option[] = [
  {label: 'Önemli', value: 'Önemli'},
  {label: 'Önemsiz', value: 'Önemsiz'},
]
export const EXTENSION: Option[] = [
  {label: 'Uzatma Yapabilir', value: 'Uzatma Yapabilir'},
  {label: 'Uzatma Yapamaz', value: 'Uzatma Yapamaz'},
]
export const PROVISION: Option[] = [
  {label: 'Normal', value: 'Normal'},
  {label: 'Yüksek', value: 'Yüksek'},
  {label: 'Düşük', value: 'Düşük'},
]
export const KM: Option[] = [
  {label: 'Normal', value: 'Normal'},
  {label: 'Sınırsız', value: 'Sınırsız'},
]
export const COST_REL: Option[] = [
  {label: 'Yansıt', value: 'Yansıt'},
  {label: 'Yansıtma', value: 'Yansıtma'},
]

export const BALANGE_PERCENTAGE: Option[] = [
  {label: '%', value: '0'},
]

export const RESERVATION_TYPES: Option[] = [
  {label: 'Broker', value: '0'},
  {label: 'Acente', value: '1'}, 
  {label: 'RentACar', value: '2'},
  {label: 'Otel', value: '3'},
  {label: 'Diğer', value: '4'},
]

export const initialReservationSource: IReservationSource = {
  reservationSourceName: '',
  company: null,
  companyId: '', 
  serviceCurrency: '1',
  workingOffice: '',
  type: '',
  maxDays: 0,
  babyseat: 0,
  navigation: 0,
  balancingType: '',
  balancingTransaction: '',
  balancePercentage: 0,
  balanceAmount: 0,
  tariffType: '',
  status: '',
  fullCreditLocation: '',
  additionalDriver: 0,
  wifi: 0,
  mandatoryServiceFee: 0,
  kdvExemptionAvailable: false,
  xmlServiceSpecial: false,
  xmlCompanyMailNotification: false,
  scdwIncluded: false,
  cdwIncluded: false,
  lcfIncluded: false,
  paiIncluded: false,
  faz1Timeout: 0,
  faz2Timeout: 0,
  automaticMailSms: '',
  xmlPaymentType: '',
  secretOption: '',
  riskAnalysis: '',
  nameDisplay: '',
  balanceNonRentConversion: '',
  automaticNoShowDuration: 0,
  futureInvoiceRate: 0,
  xmlPriceMultiplier: 0,
  xmlServiceMultiplier: 0,
  xmlAdvancePaymentRate: 0,
  frameCode: '',
  agencyPriceChange: '',
  extensionProcess: '',
  provisionType: '',
  unlimitedKm: '',
  coefficientCostRelationship: '',
}

const num = (label: string) =>
  Yup.number().typeError(`${label} sayı olmalı`).min(0, `${label} 0'dan küçük olamaz`)

export const reservationSourceValidation = Yup.object({
  reservationSourceName: Yup.string().required('Rezervasyon Kaynağı adı zorunludur'),
  serviceCurrency: Yup.string().required('Hizmet döviz zorunludur'),
  status: Yup.string().required('Durum seçilmelidir'),
  tariffType: Yup.string().required('Tarife türü zorunludur'),
  workingOffice: Yup.string().required('Çalışma Ofisi zorunludur'),
 
})
